import React, { useEffect, useState, useRef } from "react";
import * as emailjs from "emailjs-com";
import { Helmet } from "react-helmet";
import { Waypoint } from "react-waypoint";
import { useLocation } from "react-router-dom";
import {
  Flex,
  Box,
  Text,
  Heading,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  Textarea,
  Button,
} from "@chakra-ui/react";

import { toast } from "react-toastify";

import ContactBg from "../../assets/images/Logobg.jpeg";

const Contact = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [subject, setSubject] = useState("");

  const [loader, setLoader] = useState(false);

  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  const handlesSubmit = (e) => {
    e.preventDefault();

    const data = {
      from_name: `${firstName} ${lastName}`,
      from_email: email,
      phone,
      company,
      subject,
      message,
    };

    setLoader(true);

    emailjs
      .send("service_wp5941h", "template_n8d9lzr", data, "uRK5pZXblseoykbzI")
      .then(
        () => {
          toast("Mesage Sent Successfully!");
          setLoader(false);
        },
        () => {
          toast.error("There was some error in sending the message!");

          setLoader(false);
        }
      );
  };

  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <Helmet>
        <html lang="en" />

        <title>
          Contact AKIA Flow Assurance | Flow Assurance Consultant
        </title>

        <meta
          name="description"
          content="Contact AKIA Flow Assurance for flow assurance, process engineering, OLGA simulation, PIPESIM studies, hydraulic analysis, and engineering consultancy services."
        />

        <meta
          name="keywords"
          content="Contact Flow Assurance Consultant, Process Engineering Consultant, OLGA Services, PIPESIM Studies, Engineering studies Consultancy worldwide"
        />

        <meta name="author" content="AKIA Flow Assurance" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Contact AKIA Flow Assurance"
        />

        <meta
          property="og:description"
          content="Get in touch for engineering studies, process simulation, flow assurance analysis, and technical consulting support."
        />

        <link
          rel="canonical"
          href="https://akiaflowassurance.com/contact"
        />
      </Helmet>
      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82)), url(${ContactBg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}
        h={"100vh"}
        w="100vw"
        alignItems={"center"}
        justifyContent={"center"}
        color={"whiteAlpha.900"}
      >
        <Box
          width={"fit-content"}
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"4rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain7").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain7">
                <Heading
                  flexShrink={0}
                  textTransform={"uppercase"}
                  fontFamily={"Roboto Condensed, Lato, Sans-serif"}
                  fontSize={{ base: "3.7rem", "3sm": "4.5rem", lg: "5.5rem" }}
                  w={"100%"}
                >
                  Contact Us
                </Heading>
                <Box
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                  w={"100%"}
                  h={"100%"}
                />
              </Flex>
            </Waypoint>
          </Flex>
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mt={"1rem"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain8").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain8">
                <Text
                  textAlign={{ base: "justify", md: "left" }}
                
                  flexShrink={0}
                  fontSize={{ base: "1.8rem", md: "2rem" }}
                  maxW={{ base: "30rem", md: "50rem" }}
                >
                  Have a project, engineering study, or technical inquiry? <br/>
                  We'd be pleased to discuss your requirements. Send us a message, and we'll respond as soon as possible.
                </Text>
                <Box
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                  w={"100%"}
                  h={"100%"}
                />
              </Flex>
            </Waypoint>
          </Flex>
        </Box>
      </Flex>

      <Flex
        gap={"2rem"}
        justifyContent={"space-evenly"}
        py={"4rem"}
        px={{ base: "2rem", "3sm": "26rem" }}
        maxw="1440px"
        width={"100%"}
        flexDir={{ base: "column", md: "row" }}
      >
        <Waypoint
          onEnter={() =>
            (document.querySelector("#email").style.animation = "fadeUp 1.5s")
          }
        >
          <a
            style={{ flex: "0 0 36%" }}
            id="email"
            href="mailto:info@akiaflowassurance.com"
          >
            <Flex
              justifyContent={"center"}
              flexDirection={"column"}
              alignItems={"center"}
              textAlign={"center"}
              bg={"#F5F5F5"}
              p={{ base: "2rem 2rem", "2sm": "1.5rem 1rem" }}
              cursor={"pointer"}
              boxShadow={"0px 0px 5px 5px rgba(0,0,0,0.1)"}
              transition={"all 0.3s"}
              _hover={{
                boxShadow: "0px 0px 5px 5px rgba(0,0,0,0.3)",
                transform: "scale(1.05)",
              }}
            >
              <Heading fontSize={"2.2rem"}>Email</Heading>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mt={".5rem"}></Box>
              <Text fontSize={{ base: "1.8rem", md: "2rem" }} mt={"1rem"}>
                info@akiaflowassurance.com
              </Text>
            </Flex>
          </a>
        </Waypoint>
        <Waypoint
          onEnter={() =>
            (document.querySelector("#phone").style.animation = "fadeUp 1.5s")
          }
        >
          <a
            id="phone"
            style={{ flex: "0 0 36%" }}
            href="https://wa.me/971501232838"
          >
            <Flex
              justifyContent={"center"}
              flexDirection="column"
              textAlign={"center"}
              p={{ base: "2rem 2rem", "2sm": "1.5rem 1rem" }}
              alignItems={"center"}
              bg={"#F5F5F5"}
              boxShadow={"0px 0px 5px 5px rgba(0,0,0,0.1)"}
              transition={"all 0.3s"}
              _hover={{
                boxShadow: "0px 0px 5px 5px rgba(0,0,0,0.3)",
                transform: "scale(1.05)",
              }}
            >
              <Heading fontSize={"2.4rem"}>
                <i
                  className="fa-brands fa-square-whatsapp"
                  style={{ color: "green" }}
                />
              </Heading>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mt={".5rem"}></Box>
              <Text fontSize={{ base: "1.8rem", md: "2rem" }} mt={"1rem"}>
                +971501232838
              </Text>
            </Flex>
          </a>
        </Waypoint>
      </Flex>

      {/* Next Section */}
      <Flex flexDir={"column"} maxW="1200px" w={"100%"}>
        <Text px={"2.5rem"} textAlign={"justify"} fontSize="1.5rem">
          

We respect your privacy and are committed to protecting your personal information. Any details submitted through this website will be used solely to respond to your inquiries and provide information about AKIA Flow Assurance and its services. We do not sell, rent, or share your personal information with third parties except where required by law.

        </Text>
      </Flex>

      {/* Next Section */}
      <Flex my={"5rem"} width={{ base: "90%", lg: "70%" }} maxW={"800px"}>
        <form
          id="form"
          style={{ width: "100%" }}
          onSubmit={(e) => (loader ? null : handlesSubmit(e))}
        >
          <FormControl
            outline={"2px solid black"}
            p={{ base: "3rem 2rem", "3.5sm": "3rem 3rem" }}
            borderRadius={"5px"}
          >
            <Flex
              w={"100%"}
              justifyContent={"space-between"}
              gap={"2rem"}
              mb={"1rem"}
              flexDir={{ base: "column", "3.5sm": "row" }}
            >
              <Box w={{ base: "100%", "3.5sm": "50%" }}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  First Name
                </FormLabel>
                <Input
                  isRequired
                  fontSize={"1.5rem"}
                  p={"2.5rem 1rem"}
                  type="text"
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
              </Box>
              <Box w={{ base: "100%", "3.5sm": "50%" }}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  Last Name
                </FormLabel>
                <Input
                  required
                  fontSize={"1.5rem"}
                  p={"2.5rem 1rem"}
                  type="text"
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />
              </Box>
            </Flex>
            <Flex
              w={"100%"}
              justifyContent={"space-between"}
              gap={"2rem"}
              mb={"1rem"}
              flexDir={{ base: "column", "3.5sm": "row" }}
            >
              <Box w={{ base: "100%", "3.5sm": "50%" }}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  Email
                </FormLabel>
                <Input
                  isRequired
                  fontSize={"1.5rem"}
                  p={"2.5rem 1rem"}
                  type="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Box>
              <Box w={{ base: "100%", "3.5sm": "50%" }}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  Phone Number
                </FormLabel>
                <Input
                  isRequired
                  fontSize={"1.5rem"}
                  p={"2.5rem 1rem"}
                  type="text"
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
              </Box>
            </Flex>
            <Flex
              w={"100%"}
              justifyContent={"space-between"}
              gap={"2rem"}
              mb={"1rem"}
              flexDir={{ base: "column", "3.5sm": "row" }}
            >
              <Box w={{ base: "100%", "3.5sm": "50%" }}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  Company Name
                </FormLabel>
                <Input
                  fontSize={"1.5rem"}
                  p={"2.5rem 1rem"}
                  type="text"
                  onChange={(e) => {
                    setCompany(e.target.value);
                  }}
                />
              </Box>
              <Box w={{ base: "100%", "3.5sm": "50%" }}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  Subject
                </FormLabel>
                <Input
                  fontSize={"1.5rem"}
                  p={"2.5rem 1rem"}
                  type="text"
                  onChange={(e) => {
                    setSubject(e.target.value);
                  }}
                />
              </Box>
            </Flex>
            <Flex
              w={"100%"}
              justifyContent={"space-between"}
              gap={"2rem"}
              mb={"1.5rem"}
            >
              <Box w={"100%"}>
                <FormLabel fontSize={"1.5rem"} fontWeight={"700"}>
                  Messgage
                </FormLabel>
                <Input
                  resize={"none"}
                  fontSize={"1.8rem"}
                  p={"2.5rem 1rem"}
                  type="text"
                  isRequired
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                />
              </Box>
            </Flex>
            <Flex justifyContent={"center"} gap={"3rem"}>
              <Button
                bg={"#EA0F0F"}
                color={"whiteAlpha.900"}
                mt={"1rem"}
                fontSize={"1.6rem"}
                fontWeight={700}
                p={"2rem 3rem"}
                textTransform={"uppercase"}
                transition={"all 0.3s ease"}
                _hover={{
                  transform: "scale(1.05)",
                }}
                type="submit"
              >
                Submit
              </Button>
            </Flex>
          </FormControl>
        </form>
      </Flex>
      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.2rem", md: "2.5rem" }}
        >
          Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
                      id="phone"
                      style={{ flex: "0 0 22%" }}
                      href="https://wa.me/+971501232838"
                    >
                      
                        <Heading fontSize={"4rem"}>
                          <i
                            className="fa-brands fa-square-whatsapp"
                            style={{ color: "green" }}
                          />
                        </Heading>
                        
                        
                      
                    </a>

          <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Contact;
